import { render, staticRenderFns } from "./buyerBillDetail.vue?vue&type=template&id=e730b78a&"
import script from "./buyerBillDetail.vue?vue&type=script&lang=js&"
export * from "./buyerBillDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports